module.exports = __webpack_public_path__ + "img/maxplataformaadmintribdigital.e87fddd1.jpeg";